import { render, staticRenderFns } from "./PaymentsDetails.vue?vue&type=template&id=4640d008&scoped=true"
import script from "./PaymentsDetails.vue?vue&type=script&lang=js"
export * from "./PaymentsDetails.vue?vue&type=script&lang=js"
import style0 from "./PaymentsDetails.vue?vue&type=style&index=0&id=4640d008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640d008",
  null
  
)

export default component.exports